module.exports = __webpack_public_path__ + "media/taipei/photo_finish-09198e27.jpg";